export enum PropertyRecordRelationType {
    NONE,
    ABUTTING_PR,
    ABUTTING_STREET,
    PR_TAG,
}
